import { ChevronLeftIcon } from "@heroicons/react/24/outline";
import { useEffect, useState } from "react";
import toast from "react-hot-toast";
import { Link, useNavigate, useParams } from "react-router-dom";
import SpinnerLoader from "../../../../components/ui/SpinnerLoader";
import { IGTFSTripStop, IGTFSTripStopUpsert } from "../../../../interfaces/endpoints/IGTFS.types";
import { getGTFSTripStop, updateGTFSTripStop } from "../../../../services/GTFS.service";
import TripStopForm from "../TripStopForm";
import { tripStopErrorText } from "../tripStopErrors";

const EditGTFSTripStop: React.FC = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [initial, setInitial] = useState<IGTFSTripStop | null>(null);

  useEffect(() => {
    const load = async () => {
      try {
        const response = await getGTFSTripStop(Number(id));
        setInitial(response.data);
      } catch (error) {
        toast.error("Ngarkimi i ndalesës dështoi");
        navigate("/gtfs/trip-stops", { state: ["Menaxhimi i GTFS", "Ndalesat"] });
      }
    };
    void load();
  }, [id, navigate]);

  const onSubmit = async (payload: IGTFSTripStopUpsert): Promise<boolean> => {
    try {
      const response = await updateGTFSTripStop(Number(id), payload);
      if (response.status !== 200) {
        toast.error(tripStopErrorText((response as { message?: string }).message, "Ndryshimi dështoi"), {
          duration: 3500
        });
        return false;
      }
      toast.success("Ndalesa u ndryshua");
      // After the submit has settled, so the unsaved-changes prompt lets the redirect through.
      setTimeout(() => navigate("/gtfs/trip-stops", { state: ["Menaxhimi i GTFS", "Ndalesat"] }), 500);
      return true;
    } catch (error) {
      toast.error("Ndryshimi dështoi. Ju lutem kontrolloni të dhënat dhe provoni përsëri.");
      console.error("Error updating added stop:", error);
      return false;
    }
  };

  return (
    <>
      <Link
        to="/gtfs/trip-stops"
        state={["Menaxhimi i GTFS", "Ndalesat"]}
        className="flex items-center mb-4 text-primary"
      >
        <ChevronLeftIcon className="w-4 h-4 mr-2" />
        Kthehu tek lista
      </Link>
      {initial ? (
        <TripStopForm title="Ndrysho ndalesën" initial={initial} onSubmit={onSubmit} />
      ) : (
        <div className="flex justify-center items-center py-8">
          <SpinnerLoader />
        </div>
      )}
    </>
  );
};

export default EditGTFSTripStop;
